import { Button, ButtonIcon, VARIANTS } from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

import { useOpenJournalAddNoteModal } from 'features/journal';

export const JournalAddNoteButton = () => {
  const openJournalNoteAddModal = useOpenJournalAddNoteModal();

  return (
    <ButtonIcon
      aria-label="Add note"
      onClick={() => openJournalNoteAddModal()}
      position="absolute"
      bottom="10px"
      right="10px"
      as={Button}
      color={VARIANTS.PRIMARY}
      zIndex={11}
    >
      <Icon name={iconNames.plus} stroke="var(--fgPrimaryInverse)" />
    </ButtonIcon>
  );
};
